(function ($) {

    function loadMoreNews() {

        let moreNewsButton = $('.js-posts-more');
        moreNewsButton.show();
        moreNewsButton.attr('disabled', 'disabled').text('loading...');

        // window.history.pushState({}, '', window.location.toString().replace(/page\/(\d+)\/?/, '') + 'page/' + (moreNewsButton.data('page') + 1), null);

        let data = {
            'action': 'load_more_resources',
            'cat': moreNewsButton.data('cat'),
            'page': moreNewsButton.data('page')
        };

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            dataType: 'json',
            type: 'POST',
            beforeSend: function (xhr) {
                moreNewsButton.text('loading...'); // change the moreNewsButton text, you can also add a preloader image
            },
            success: function (data) {

                $('.js-post-card-container').removeClass('is-loading');
                if (data) {
                    moreNewsButton.text('more').show();

                    if (data.content.length) {
                        $('.js-post-card-container').append(data.content);
                    }

                    let nextPage = moreNewsButton.data('page') + 1;
                    console.log(nextPage);

                    // window.resource_params.current_page++;
                    moreNewsButton.data('page', nextPage);

                    if (!data.more_pages)
                        moreNewsButton.hide();

                } else {
                    moreNewsButton.hide();
                }
            }
        });
    }

    $('.js-posts-more').on('click', function (e) {
        e.preventDefault();
        loadMoreNews();
    })

}(jQuery));
